export default {
    API_URL: 'http://localhost:8080/api/',
    VUE_APP_ABOUT_PAGE_HTML_BASE_URL: 'http://localhost:8081/',
    BASE_URL: 'http://localhost:8080/',
    AUTH_URL: 'https://auth-test.estravel.ee/oidc/endpoint/oidprovider',
    AUTH_CLIENT_ID: 'extranet-localhost',
    AUTH_CLIENT_SECRET: '7up291inBR4T71QzcOgtt4UMboon0nEr',
    GA4_MEASUREMENT_ID: ''
}
